var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconFavorite = function SvgIconFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.643 1.5c3.32 0 5.857 3.118 5.857 5.857 0 4.376-1.906 7.154-7.749 12.92l-1.892 1.867a1.212 1.212 0 0 1-1.718 0l-2.225-2.197C3.334 14.404 1.5 11.649 1.5 7.357 1.5 4.618 4.038 1.5 7.357 1.5c1.63 0 3.15.65 4.327 1.814l.205.21.111.125.111-.124c1.077-1.16 2.471-1.864 3.988-2l.286-.02.258-.005zm0 2.429c-1.696 0-2.856 1.022-3.557 2.424-.427.852-1.745.852-2.172 0-.7-1.402-1.861-2.424-3.557-2.424-1.934 0-3.428 1.97-3.428 3.428 0 3.396 1.503 5.683 6.42 10.59L12 19.576l1.345-1.324c5.161-5.118 6.726-7.429 6.726-10.894 0-1.458-1.494-3.428-3.428-3.428z",
    fill: "#636363"
  })));
};

export default SvgIconFavorite;